




















import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientProductsValue } from "@/data/models/ClientAdministrationRow";
import { PRODUCT_SWITCHES } from "@/utils/ClientProducts";
import { ClientSetupDraft } from "@/utils/ClientSetupDraft";

@Component
export default class SetupProductsStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;

  products = PRODUCT_SWITCHES;

  onChange(product: keyof ClientProductsValue, on: boolean | null) {
    const before = { ...this.draft.products };
    this.draft.products[product] = on === true;
    this.$emit("changed", before);
  }
}
